/* eslint-disable no-extend-native */
function fn(callback) {
  if (!callback) {
    throw new Error('fetch 的 finally 方法必须传递 callback 参数')
  }
  const P = this.constructor
  return this.then(
    res => P.resolve(callback()).then(() => res),
    err =>
      P.resolve(callback()).then(() => {
        throw err
      })
  )
}

Promise.prototype.finally = fn



// WEBPACK FOOTER //
// ./src/utils/promise-enhance.js